import React from 'react';

import Spinner from 'components/loader/Spinner';
import { BackButton } from 'components/buttons';
import Header from 'components/header/Header';
import useCluster from './hooks/useCluster';
import { StackType } from '../Stack/StackDetails';
import StatusWithTooltip from 'components/StatusWithTooltip/StatusWithTooltip';
import StackDetails from '../Stack/StackDetails';
import EditorDetails from 'components/details/EditorDetails';

// TODO: ADD EDIT FUNCTIONALITY WHEN THE API QUERY IS READY
// TODO: ENABLE DELETE FUNCTIONALITY WHEN THE API QUERY IS FIXED
const WarehouseView = () => {
    const { cluster, items, error, loading } = useCluster();

    return (
        <div>
            {loading ? (
                <Spinner />
            ) : (
                <div>
                    {Object.keys(cluster).length > 0 && (
                        <div>
                            <Header title={cluster.label} backButton />
                            <div className="flex items-center gap-8">
                                <div className="text-true-blue text-sm">
                                    Created: {items.created}
                                </div>
                                <StatusWithTooltip
                                    content={cluster.stack.status}
                                />
                            </div>
                            <div className="info-container">
                                <h3 className="text-2xl font-bold">
                                    Warehouse details
                                </h3>
                                <EditorDetails
                                    loading={loading}
                                    error={error}
                                    items={items}
                                    type="dataset"
                                />
                            </div>
                            <div className="info-container">
                                <h3 className="text-2xl font-bold">
                                    Stack details
                                </h3>
                                <StackDetails type={StackType.warehouse} />
                            </div>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
};

export default WarehouseView;
